const Card = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 8a2.5 2.5 0 0 1 2.5-2.5h11A2.5 2.5 0 0 1 20 8v8a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 16zm2.5-1.5A1.5 1.5 0 0 0 5 8v1h14V8a1.5 1.5 0 0 0-1.5-1.5zM19 11H5v5a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 19 16z"
      clipRule="evenodd"
    />
  </>
)
export default Card
